var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03325 55.7539H53.9667C54.7452 55.7538 55.5104 55.5517 56.1874 55.1673C56.8645 54.783 57.4302 54.2296 57.8294 53.5612C58.2285 52.8928 58.4475 52.1323 58.4648 51.3539C58.4821 50.5756 58.2972 49.8061 57.9281 49.1206L33.9628 4.61281C32.2626 1.45719 27.7373 1.45719 26.0372 4.61281L2.07185 49.1206C1.70278 49.8061 1.51786 50.5756 1.53517 51.3539C1.55247 52.1323 1.77141 52.8928 2.17058 53.5612C2.56975 54.2296 3.13549 54.783 3.81253 55.1673C4.48957 55.5517 5.25473 55.7538 6.03325 55.7539V55.7539Z",
    stroke: "url(#paint0_linear_355_763)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1928 20.4766L30 37.6329L30.8058 20.4837C30.8107 20.374 30.7933 20.2646 30.7545 20.1619C30.7158 20.0592 30.6565 19.9655 30.5803 19.8866C30.5041 19.8076 30.4125 19.745 30.3113 19.7026C30.2101 19.6602 30.1013 19.6389 29.9916 19.6399V19.6399C29.8837 19.641 29.7772 19.6636 29.6783 19.7065C29.5794 19.7494 29.49 19.8117 29.4156 19.8897C29.3411 19.9677 29.2831 20.0598 29.2448 20.1606C29.2065 20.2614 29.1889 20.3689 29.1928 20.4766V20.4766Z",
    stroke: "url(#paint1_linear_355_763)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 48.8633C29.4437 48.8633 28.9 48.6983 28.4375 48.3893C27.9749 48.0802 27.6145 47.641 27.4016 47.1271C27.1887 46.6132 27.133 46.0477 27.2415 45.5021C27.3501 44.9565 27.6179 44.4554 28.0113 44.062C28.4046 43.6687 28.9057 43.4008 29.4513 43.2923C29.9969 43.1838 30.5624 43.2395 31.0763 43.4524C31.5902 43.6652 32.0295 44.0257 32.3385 44.4882C32.6476 44.9508 32.8125 45.4945 32.8125 46.0508C32.8125 46.7967 32.5162 47.5121 31.9887 48.0395C31.4613 48.567 30.7459 48.8633 30 48.8633Z",
    fill: "url(#paint2_linear_355_763)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_355_763",
    x1: 58.4659,
    y1: 29,
    x2: 1.53406,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_355_763",
    x1: 30.8066,
    y1: 28.6364,
    x2: 29.1923,
    y2: 28.6364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_355_763",
    x1: 32.8125,
    y1: 46.0508,
    x2: 27.1875,
    y2: 46.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F04F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8B70"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationIcon);
export default __webpack_public_path__ + "static/media/confirmation-icon.4c58eee36bf2db261b82254f31fa2aea.svg";
export { ForwardRef as ReactComponent };